const FIELD_TO_SECTION: Record<string, string> = {
  organizational: "organisation",
  service: "service",
  invited_modes: "service",
  schedule: "schedule",
  packing_list: "packing-list",
  packing: "packing-list",
  shipment: "provider",
  invited_providers: "provider",
  bucket_attachments: "provider",
  other_attachments: "provider",
};

const CLEARANCE_FIELD_PATTERN = /^service\.(export|import|transit)_clearance(_instructions)?$/;

export function getSectionKeyForFieldPath(fieldPath: string): string | undefined {
  if (fieldPath === "shipment.title") {
    return "organisation";
  }
  if (CLEARANCE_FIELD_PATTERN.test(fieldPath)) {
    return "schedule";
  }
  if (fieldPath === "service.service_level") {
    return "schedule";
  }
  const topLevel = fieldPath.split(".")[0];
  return FIELD_TO_SECTION[topLevel];
}
